import { useEnv } from '@/components/providers/env-provider';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import Fetch from '@/services/fetch/Fetch';
import { PhraseJob } from '@/shared-types/phraseTypes';
import { formattedDate } from '@/utils/date';
import { envToBaseUrl } from '@/utils/env';
import { useQuery } from '@tanstack/react-query';

export function Jobs() {
  const { env } = useEnv();
  const endpoint = `${envToBaseUrl(env)}/phrase/jobs`;

  const { data } = useQuery<PhraseJob[]>({
    queryKey: ['get-jobs', { endpoint, env }],
    queryFn: () => Fetch.json(endpoint),
    refetchOnWindowFocus: false,
  });

  return (
    <>
      <p className='mb-5'>
        Phrase jobs are automatically created daily at 3 PM. If updated
        translations (en-XZ) are found, a job is created.
      </p>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Created</TableHead>
            <TableHead>Updated</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data?.map((job) => (
            <TableRow key={job.name}>
              <TableCell>{job.name}</TableCell>
              <TableCell>{job.state}</TableCell>
              <TableCell>{formattedDate(job.created_at)}</TableCell>
              <TableCell>{formattedDate(job.updated_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
